import React, { useEffect, useState } from "react";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import Translator from "Languages/Utility/Translator";
import { satc_accountingManualCredit } from "Constants/TableColumns";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { useTranslation } from "react-i18next";
import { useSetState } from "Helpers/Hooks";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Grid from "@material-ui/core/Grid";
import { read } from "Helpers/LocalStorage";
import { Skeleton } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { getAccountingManualCredit, getAccountsAllGroup } from "Stores/actions";
import BackDropLoading from "Components/BackDropLoading2/BackDropLoading";
import NewIncCredit from "./NewIncCredit";
import PageTitle from "Components/PageTitle_IconCircle/PageTitle";

export default function IncCredit() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState();
  const { accountingManualCredit, allGroups, pagination } = useSelector(
    (state) => ({
      accountingManualCredit: state.saAccounts.accountingManualCredit,
      allGroups: state.saAccounts.allGroups,
      pagination: state.saAccounts.pagination,
    })
  );
  const [controls, setControls] = useSetState({
    groups: {
      type: "select",
      selectItems: [],
      value: null,
      validation: null,
    },
  });

  useEffect(() => {
    onEnter();
  }, []);

  const onEnter = async () => {
    setLoading(true);
    setControls({ groups: { value: null } });
    await getAllGroups();
    await getManualCredit();
  };

  const getAllGroups = async () => {
    return new Promise((resolve) => {
      (async () => {
        try {
          const params = {
            KeyGroup: read("groupAKey"),
            KeyUser: read("userAKey"),
          };
          await dispatch(getAccountsAllGroup(params));
          resolve(true);
        } catch (err) {
          console.error("Promise error:", err);
          resolve(false);
        }
      })();
    });
  };

  const getManualCredit = async (
    _page = currentPage,
    _sizePerPage = sizePerPage,
    group = null
  ) => {
    setLoading(true);
    return new Promise((resolve) => {
      (async () => {
        try {
          let dataSearch = {};
          if (group && group.value !== -1) dataSearch.GroupId = group.value;
          else if (controls.groups.value)
            if (controls.groups.value.value !== -1)
              dataSearch.GroupId = controls.groups.value.value;
          const params = {
            KeyGroup: read("groupAKey"),
            KeyUser: read("userAKey"),
            Limit: _sizePerPage,
            Page: _page,
            ...dataSearch,
          };
          await dispatch(getAccountingManualCredit(params));
          setLoading(false);
          resolve(true);
        } catch (err) {
          console.error("Promise error:", err);
          setLoading(false);
          resolve(true);
        }
      })();
    });
  };

  useEffect(() => {
    if (accountingManualCredit) {
      setTblData(accountingManualCredit);
      setSizePerPage(pagination.Limit);
      setCurrentPage(pagination.Page);
      setTotal(pagination.Total);
    }
  }, [accountingManualCredit]);

  useEffect(() => {
    if (allGroups) {
      const selectItems = allGroups.map((child) => {
        return {
          label: child.Name,
          value: child.Id,
        };
      });
      setControls({ groups: { selectItems } });
      setControls({ groups: { value: selectItems[0] } });
    }
  }, [allGroups]);

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      await getManualCredit(page, sizePerPage);
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    await getManualCredit(1, sizePerPage, { value: value.value });
  };

  const getDataAgain = async () => {
    await getManualCredit();
  };

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-3">
        <PageTitle title={<Translator id="incCredit" />} />
        <div className="top-buttons">
          <NewIncCredit disabled={loading} getDataAgain={getDataAgain} />
        </div>
      </div>
      <MuiPaper>
        <Grid container spacing={2} className="mb-2">
          {Object.keys(controls).map((key) => {
            return (
              <Grid item md={3} sm={6} xs={12} key={key}>
                {!loading ? (
                  controls[key].type === "select" && (
                    <MuiAutoComplete
                      autoSelect={true}
                      options={controls[key].selectItems}
                      label={<Translator id={key} />}
                      value={controls[key].value}
                      onChange={autoCompleteHandler}
                      disabled={loading}
                      id={key}
                    />
                  )
                ) : (
                  <Skeleton variant="text" className="p-2" animation="wave" />
                )}
              </Grid>
            );
          })}
        </Grid>
        <RemoteTable
          data={tblData}
          columns={satc_accountingManualCredit}
          loading={loading}
          page={currentPage}
          sizePerPage={sizePerPage}
          totalSize={total}
          onTableChange={onTableChange}
        />
      </MuiPaper>
    </>
  );
}
